<template>
	<v-container class="pt-0">
		<v-row no-gutters>
			<v-col>
				<v-card class="elevation-1 justify-center text-center" color="white">
					<v-card-title @click="goBack()">
						<v-btn text class="secondary--text font-weight-bold"> <v-icon large color="secondary" @click="cancelLocumSearch()">keyboard_backspace</v-icon>Back </v-btn>
						<v-spacer></v-spacer>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-row readonly flat>
							<v-col>
								<v-list-item>
									<v-list-item-content align="center" justify="center">
										<v-list-item-title class="title font-weight-black" v-text="'Booking Summary'"></v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-col>
						</v-row>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-text>
						<v-row readonly flat align="center" justify="center">
							<v-col align="center" justify="center">
								<v-list-item style="font-family: Montserrat; font-style: normal; font-weight: normal; font-size: 16px; line-height: 20px !important">
									You are booking {{ this.locum.first_name }} {{ this.locum.last_name }} for the following days
								</v-list-item>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-text class="pt-0 mt-0">
						<v-row no-gutters>
							<v-col v-for="(day, index) in this.summaryDays" :key="'card-' + index" :cols="summaryDays.length > 12 ? '4' : '6'" align="center" justify="center">
								<div align="center" justify="center" class="pb-2">
									<CalendarDateIcon :date="day.date" color="green"></CalendarDateIcon>
								</div>
							</v-col>
						</v-row>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-text class="pt-5 pb-1"> <b>From</b> {{ this.theOffer.start_time }} <b>to</b> {{ this.theOffer.end_time }} </v-card-text>
					<v-card-text class="pt-2 pb-0">
						<v-list-item-content class="pt-0 pb-0">
							<p>
								<b>Lunch Details:</b>
							</p>
							<span>{{ lunchDetails }}</span>
						</v-list-item-content>
					</v-card-text>
					<v-card-text>
						<v-row no-gutters>
							<v-col>
								<v-textarea v-model="notes" label="Notes (optional)" background-color="#F4F4F4" rounded outlined no-resize></v-textarea>
							</v-col>
						</v-row>
					</v-card-text>

					<v-card-actions>
						<v-row>
							<v-col>
								<v-btn outlined style="background: #ffffff; border: 1px solid primary; box-sizing: border-box; border-radius: 100px"
									><div
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: bold;
											font-size: 16px;
											line-height: 20px;
											text-align: center;
											color: var(--v-primary-base);
										"
										@click="goBack()"
									>
										Cancel
									</div></v-btn
								>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-btn style="background: var(--v-primary-base); box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05); border-radius: 100px" @click="endpoint"
									><div
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: bold;
											font-size: 16px;
											line-height: 20px;
											text-align: center;
											color: #ffffff;
										"
									>
										Confirm
									</div></v-btn
								>
							</v-col>
						</v-row>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import store from '@/store';
import { mapActions } from 'vuex';
import CalendarDateIcon from '@/components/custom/CalendarDateIcon.vue';

import axios from 'axios';
import moment from 'moment';
import { bus } from '@/main';

export default {
	name: 'PracticeToLocumBookingSummary',
	components: { CalendarDateIcon },
	data: () => ({
		items: {},
		keyboi: 0,

		buttonColor: 'red',

		trackedDates: {},

		apiRequest: false,
		API_URL: store.getters.getAPI,
		locums: [
			{
				avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
				name: 'Jane Doe',
				profession: 'Dentist',
				datetime: '9:00AM -> 11:00PM (2 Hours)',
				location: '',
				university: '',
				bio: 'Lorem Ipsum Lorem Ipsum',
				rating: 4.5,
			},
		],

		starttime: '',
		endtime: '',

		starttimemodal: false,
		endtimemodal: false,

		switch1: false,
		switch2: false,
		switch3: false,

		notes: '',

		hashourlunch: null,
	}),
	computed: {
		locum() {
			return store.getters.getPracticeViewingLocum[0];
		},
		locumRates() {
			return {
				public_holidays: this.locum.working_hours.public_holidays.rate,
				sundays: this.locum.working_hours.sundays.rate,
				saturday: this.locum.working_hours.saturday.rate,
				weekdays: this.locum.working_hours.weekdays.rata,
			};
		},
		summaryDays() {
			return store.getters.getSummaryTrackedAvailabilities;
		},
		theOffer() {
			return store.getters.getPracticeOffer;
		},
		endpoint() {
			return store.getters.getSummaryTrackedAvailabilities.some(day => !day.availability) ? this.sendPrivateBookingRequest : this.sendBookingRequest;
		},
		companyAddressAsString() {
			let result = {};
			Object.keys(store.getters.company.address).forEach(key => {
				if (key != 'update_timestamp') {
					result[key] = store.getters.company.address[key];
				}
			});
			return result;
		},
		lunchDetails() {
			if (!this.theOffer.lunch) {
				return '';
			}
			const { allowed, paid, period } = this.theOffer.lunch;

			if (!allowed) {
				return 'No Lunch Break';
			}

			const timePeriod = period === 0.5 ? '30 minutes' : '1 hour';

			return paid ? `Paid ${timePeriod} Lunch Break` : `Unpaid ${timePeriod} Lunch Break`;
		},
	},
	methods: {
		...mapActions(['SET_PRACTICE_LOCUMS_APPLIED_TO']),

		viewLocumProfile() {
			bus.$emit('change-context', 'practice-locum-profile');
		},
		goBack() {
			bus.$emit('change-context', 'practice-to-locum-create-booking-request');
		},
		cancelLocumSearch() {
			bus.$emit('change-context', 'practice-locum-search-results');
		},
		async sendBookingRequest() {
			let summaryDays = this.summaryDays;
			let availabilities = {};
			console.log('hellp');
			summaryDays.forEach(day => {
				if (!(day.availability.date in availabilities)) {
					availabilities[day.availability.date] = [];
				}
				availabilities[day.availability.date].push(day);
			});

			let requests = Object.values(availabilities).map(group_of_availability_days => ({
				url: '/calendar/professional/availability/request-booking/' + group_of_availability_days[0].availability.id + '/' + group_of_availability_days[0].availability.date,
				availability_id: group_of_availability_days[0].availability.id,
				availability_day: group_of_availability_days[0].availability.date,
				body: {
					id: this.theOffer.company.id,
					name: store.getters.company.name,
					email: store.getters.company.email,
					contact: this.theOffer.company.contact,
					industry: this.theOffer.company.industry,
					start_time: this.theOffer.start_time,
					end_time: this.theOffer.end_time,
					address: this.companyAddressAsString,
					lunch: this.theOffer.lunch,
					notes: this.notes,
					rates: this.theOffer.rates,
					status: 'requested',
					booking_dates: group_of_availability_days.map(day => day.date).sort((a, b) => moment(a).diff(moment(b))),
				},
			}));
			let token = store.getters.jwtToken;

			let axios_requests = requests.map(request => axios.put(store.getters.getAPI + request.url, request.body, { headers: { Authorization: token } }));

			let responses = await axios.all(axios_requests);
			responses.forEach(avail => {
				avail.data.data.booking_requests.forEach(request => {
					store.commit('PUSH_CHANNEL_NOTIFICATION', { channel: 'BookingRequestsSent', identity: 'A' + request.booking_ref });
				});
			});
			store.dispatch('SET_PRACTICE_REQUESTS_SENT', requests);
			this.SET_PRACTICE_LOCUMS_APPLIED_TO(this.locum.id);
			bus.$emit('change-context', 'practice-request-multiple-locums');
		},

		async sendPrivateBookingRequest() {
			let summaryDays = this.summaryDays.sort((a, b) => moment(a.date).diff(moment(b.date)));
			let locum = this.locum;
			console.log(this.theOffer.company.address);
			'update_timestamp' in this.theOffer ? delete this.theOffer.update_timestamp : null;
			'update_timestamp' in this.theOffer.company.address ? delete this.theOffer.company.address.update_timestamp : null;
			let request = {
				url: '/offers/company/private',
				body: {
					start_time: this.theOffer.start_time,
					end_time: this.theOffer.end_time,
					date: summaryDays[0].date,
					end_date: summaryDays[summaryDays.length - 1].date,
					company: this.theOffer.company,
					notes: this.notes,
					profession: this.theOffer.profession,
					experience: this.theOffer.experience,
					languages: this.theOffer.languages,
					lunch: this.theOffer.lunch,
					available_dates: summaryDays.map(day => day.date).sort((a, b) => moment(a).diff(moment(b))),
					rates: this.theOffer.rates,
					offers_requests: [
						{
							id: locum.id,
							name: locum.first_name,
							surname: locum.last_name,
							contact: locum.contact,
							profession: locum.profession,
							email: locum.email,
							qualifications: {
								qualification: locum.qualifications.qualification,
								institution: locum.qualifications.institution,
								year_qualified: moment(locum.qualifications.year_qualified).format('YYYY'),
							},
							rates: {
								weekdays: 'R' + locum.working_hours.weekdays.rate,
								saturday: 'R' + locum.working_hours.saturday.rate,
								sundays: 'R' + locum.working_hours.sundays.rate,
								public_holidays: 'R' + locum.working_hours.public_holidays.rate,
							},
							status: 'requested',
							status_reason: '',
							experience: moment(locum.experience.start_date).format('YYYY-MM-DD'),
							booking_dates: summaryDays.map(day => day.date).sort((a, b) => moment(a).diff(moment(b))),
						},
					],
				},
			};

			let token = store.getters.jwtToken;
			let axios_requests = [request].map(requestm => {
				axios.post(store.getters.getAPI + requestm.url, requestm.body, { headers: { Authorization: token } });
			});

			axios
				.all(axios_requests)
				.then(async () => {
					await store.dispatch('SET_PRACTICE_REQUESTS_SENT', [request]);
					this.SET_PRACTICE_LOCUMS_APPLIED_TO(this.locum.id);
					bus.$emit('change-context', 'practice-request-multiple-locums');
				})
				.catch(responses => {
					console.error('[axios] ERROR send booking requests axios ->', responses);
				});
		},
		colorOfIndex(index) {
			if (!(index in this.trackedDates)) {
				this.trackedDates[index] = false;
			}
			return this.trackedDates[index] ? 'green' : 'red';
		},
		OnClick(index) {
			this.keyboi += 1;
			if (!(index in this.trackedDates)) {
				this.trackedDates[index] = true;
			} else {
				this.trackedDates[index] = !this.trackedDates[index];
			}
		},
	},
};
</script>
